module.exports = {
	"name": "Logitech F310 (DirectInput) Chrome Linux",
	"supported": [
		{
			"id": "Logitech Logitech Dual Action (Vendor: 046d Product: c216)",
			"os": "Linux",
			"browser": "Chrome"
		}
	],
	"axes": {
		"left stick x": {
			"index": 0
		},
		"left stick y": {
			"index": 1
		},
		"right stick y": {
			"index": 3
		},
		"dpad x": {
			"index": 4
		},
		"dpad y": {
			"index": 5
		},
		"right stick x": {
			"index": 2
		}
	},
	"buttons": {
		"b": {
			"index": 2
		},
		"left stick": {
			"index": 10
		},
		"dpad left": {
			"axis": 4,
			"direction": -1
		},
		"dpad right": {
			"axis": 4,
			"direction": 1
		},
		"dpad up": {
			"axis": 5,
			"direction": -1
		},
		"dpad down": {
			"axis": 5,
			"direction": 1
		},
		"left trigger": {
			"index": 6
		},
		"right trigger": {
			"index": 7
		},
		"left shoulder": {
			"index": 4
		},
		"right shoulder": {
			"index": 5
		},
		"y": {
			"index": 3
		},
		"x": {
			"index": 0
		},
		"a": {
			"index": 1
		},
		"left stick left": {
			"axis": 0,
			"direction": -1
		},
		"left stick right": {
			"axis": 0,
			"direction": 1
		},
		"left stick up": {
			"axis": 1,
			"direction": -1
		},
		"left stick down": {
			"axis": 1,
			"direction": 1
		},
		"back": {
			"index": 8
		},
		"start": {
			"index": 9
		},
		"right stick left": {
			"axis": 2,
			"direction": -1
		},
		"right stick right": {
			"axis": 2,
			"direction": 1
		},
		"right stick up": {
			"axis": 3,
			"direction": -1
		},
		"right stick down": {
			"axis": 3,
			"direction": 1
		},
		"right stick": {
			"index": 11
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/html5-gamepad/mappings/logitechf310-directinput-chrome-linux.json
// module id = 201
// module chunks = 0